// 월세페이 후기(리뷰) API URL 상수 (NZSC-3259)
// baseURL = VUE_APP_HOST (api.js), /api/v1 prefix 는 여기서 포함.
export default {
  // 후기 작성 (미자격이면 서버 403 → apiWrapper null 반환)
  POST_WOLSE_REVIEW: "/api/v1/wolse-review",
  // 내 후기 목록 (본인 세션에서만 상단 노출용)
  GET_WOLSE_REVIEW_MINE: "/api/v1/wolse-review/mine",
  // 작성 자격 (월세페이 결제 유무) → { eligible: boolean }
  GET_WOLSE_REVIEW_ELIGIBILITY: "/api/v1/wolse-review/eligibility",
};
